import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { mountEnvRibbon } from "./envRibbon";

// Anything that is not production wears a visible marker, so a dev tab is
// never mistaken for the real console.
mountEnvRibbon(import.meta.env.VITE_APP_ENV, "datos de prueba");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
